module.exports = "<app-list-display [title]=\"'Publications'\" [component_id]=\"'publications'\" [items]=\"projects\"></app-list-display>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/spina-me/source/src/app/publications/publications.component.html
// module id = ../../../../../src/app/publications/publications.component.html
// module chunks = 1